
import React, { useEffect } from 'react';
import { toast } from 'sonner';

interface DeepgramKeyInputProps {
  onApiKeySet: (key: string) => void;
  apiKey: string;
}

const DeepgramKeyInput: React.FC<DeepgramKeyInputProps> = ({ onApiKeySet, apiKey }) => {
  // Use the permanent API key
  const permanentApiKey = "8ec5e65274afa8b4aaddbacdac4f1d98b95f6f90";
  
  // Set the API key on component mount if it's not already set
  useEffect(() => {
    if (!apiKey && permanentApiKey) {
      onApiKeySet(permanentApiKey);
      toast.success("Voice recording is ready to use", {
        id: "deepgram-api-key-set",
      });
    }
  }, [apiKey, onApiKeySet, permanentApiKey]);
  
  // This component no longer renders any UI
  return null;
};

export default DeepgramKeyInput;
